// Utility functions for quiz results

export const getScoreColor = (score) => {
  if (score >= 80) return 'text-green-500'; // Custom class for success
  if (score >= 60) return 'text-yellow-500'; // Custom class for warning
  return 'text-red-500'; // Custom class for danger
};

export const getScoreBadge = (score) => {
  if (score >= 80) return 'success'; // Custom class for success badge
  if (score >= 60) return 'warning'; // Custom class for warning badge
  return 'danger'; // Custom class for danger badge
};

export const getPerformanceMessage = (score) => {
  if (score >= 90) return 'Excellent work! You have mastered these concepts.';
  if (score >= 80) return 'Great job! You have a solid understanding.';
  if (score >= 70) return 'Good work! Review the areas you missed.';
  if (score >= 60) return 'Not bad! Consider reviewing the material.';
  return 'Keep studying! Review the concepts and try again.';
};

export const getQuestionById = (quiz, questionId) => {
  return quiz?.questions?.find(q => q.question_id === questionId);
};
